// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#featured-projects[data-v-4a27a38c]{background-color:#fff}.fade-in[data-v-4a27a38c]{-webkit-animation:fade-in-data-v-4a27a38c 1.5s cubic-bezier(.39,.575,.565,1) both;animation:fade-in-data-v-4a27a38c 1.5s cubic-bezier(.39,.575,.565,1) both}@-webkit-keyframes fade-in-data-v-4a27a38c{0%{opacity:0}to{opacity:1}}@keyframes fade-in-data-v-4a27a38c{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
